import React, { useState, useEffect } from "react";
import { PendingNavbar } from "./reusedcomponent/Navbar";

import { ApiService } from "../../../services/ApiService";
import { useAlert } from "react-alert";
import { ConfirmTemplate } from "../../../components/confirm";
("./model/reject");
import RejectOfficeModal from "./model/reject";
("./modal/reject");
import useModal from "../../../utils/useModal";
import Modal from "react-modal";

import EditrequestModal from "./model/edit_request";
import { capitalize } from "../../../utils/capitalize";
import { formattCurrency } from "../../../utils/formatCurrency";
import Checkbox from "./reusedcomponent/checkBox";
import moment from "moment";
import { set } from "lodash";

const customStyles = {
  content: {
    top: "50%",
    left: "50%",
    right: "50%",
    bottom: "auto",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",
    background: "white",
  },
};

export const pendingOfficeRequests = () => {
  const alert = useAlert();

  const [pendingRequests, setPendingRequests] = useState({
    data: [],
    requestType: [],
    indevReqType: [],
    officeReqType: [],
    next: null,
    prev: "",
    currentPage: 1,
    last: "",
  });
  const [checkedItems, setCheckedItems] = useState([]);
  const [checkedAll, setCheckedAll] = useState(false);

  const { modalIsOpen, openModal, closeModal } = useModal();
  const [EditValue, setEditValue] = useState([]);
  const [open, setOpen] = useState(false);

  const [Loading, setLoading] = useState(false);
  const load = <span className="fa fa-spin fa-spinner"></span>;

  const openEditModal = () => {
    setOpen(true);
  };

  const closeEditModal = () => {
    setOpen(false);
  };

  const approveManyRequest = (ids) => {
    const request = async () => {
      setLoading(true)
      const request_id = {
        request_id: ids,
      };
      const res = await ApiService.post("requests/approve-request", request_id);
      if (res.data.type === false || res.data.errors) {
        if (res.data.errors) {
          let meesg = res.data.errors[0];
          alert.error(meesg);
        }
        alert.error(res.data.msg);
      } else if (res.data.type === true) {
        alert.success(res.data.msg);
        getPendingRequests();
      }
      getPendingRequests();
      setCheckedItems([]);
      setCheckedAll(false);
      setLoading(false)
    };
    ConfirmTemplate(
      {
        title: "Approve Requests",
        message: "Are You Sure ?",
      },
      request
    );
  };

  const rejectRequests = async (ids, reason) => {
    setLoading(true)
    const request_id = {
      request_id: ids,
      reason_for_rejection: reason,
    };
    const res = await ApiService.post("requests/reject-request", request_id);
    if (res.data.type === false || res.data.errors) {
      if (res.data.errors) {
        let meesg = res.data.errors[0];
        alert.error(meesg);
      }
      alert.error(res.data.msg);
    } else if (res.data.type === true) {
      alert.success(res.data.msg);
    }
    getPendingRequests();
    setCheckedItems([]);
    setCheckedAll(false);
    setLoading(false)
  };

  const confirmRejection = () => {
    const request = () => {
      openModal();
    };
    ConfirmTemplate(
      {
        title: "Reject Requests",
        message: "Are You Sure ?",
      },
      request
    );
  };

  const getPendingRequests = async (query = "?page=1") => {
    const response = await ApiService.get(`requests/pending${query}`);
    const Requests = !Array.isArray(
      response.data && response.data.requests.data
    )
      ? Object.values(response.data && response.data.requests.data)
      : response.data.requests.data;

    const request = Requests.map((d) => {
      return { ...d, isChecked: false };
    });

    const { last_page_url, prev_page_url, next_page_url, current_page } =
      response.data.requests;

    setPendingRequests({
      data: request,
      requestType: response.data.requestType,
      indevReqType: response.data.individualRequestsCategories,
      officeReqType: response.data.officeRequestsCategories,
      last: last_page_url,
      prev: prev_page_url,
      currentPage: current_page,
      next: next_page_url,
    });
    setLoading(false);
  };

  const handleAllChecked = (event) => {
    let leavess = pendingRequests.data;
    let checkIds = new Set(checkedItems);
    leavess.forEach((l) => (l.isChecked = event.target.checked));
    leavess.forEach((l) => {
      if (l.isChecked) {
        checkIds.add(l.id);
      } else {
        checkIds = new Set();
      }
    });
    setCheckedItems([...checkIds]);
    setPendingRequests({ data: leavess });
    setCheckedAll(!checkedAll);
  };

  const handleCheckChieldElement = (event) => {
    let leaves = pendingRequests.data;
    let checkIds = [...new Set(checkedItems)];
    leaves.forEach((l) => {
      if (l.id === Number(event.target.value))
        l.isChecked = event.target.checked;
    });

    leaves.forEach((l) => {
      if (l.isChecked) {
        checkIds.push(l.id);
      }
      if (l.isChecked == false && checkIds.indexOf(l.id) !== -1) {
        checkIds.splice(checkIds.indexOf(l.id), 1);
      }
    });

    setCheckedItems([...new Set(checkIds)]);
    setPendingRequests({ data: leaves });
    setCheckedAll(false);
  };

  useEffect(() => {
    getPendingRequests();
  }, []);

  const handleApprove = () => {
    approveManyRequest(checkedItems);
  };

  const handlereject = () => {
    confirmRejection();
  };

  console.log("office--checkedItems", pendingRequests.requestType);

  let activePage = pendingRequests.currentPage;

  return (
    // <PageBody isLoading={isLoading} message={message}>
    <React.Fragment>
      <PendingNavbar />

      <Modal
        isOpen={modalIsOpen}
        onRequestClose={closeModal}
        style={customStyles}
        contentLabel="view user datails modal"
      >
        <RejectOfficeModal
          alert={alert}
          request={checkedItems}
          closeModal={closeModal}
          orgarnizationMngmnt={getPendingRequests}
          rejectRequests={rejectRequests}
        />
      </Modal>

      <Modal
        isOpen={open}
        onRequestClose={closeEditModal}
        style={customStyles}
        contentLabel="view user datails modal"
      >
        <EditrequestModal
          alert={alert}
          pendingRequest={pendingRequests}
          value={EditValue}
          closeModal={closeEditModal}
          getAllRequest={getPendingRequests}
          approveRequest={approveManyRequest}
        />
      </Modal>
      <div className="content">
        <div className="container-fluid">
          <div className="row">
            <div className="col-lg-12 grid-margin">
              <div className="card">
                <div className="card-body">
                  <div className="card-title">
                    <div className="table-title">
                      <div className="row container-fluid">
                        <div className="col-sm-5">
                          <h2>
                            <b>PENDING OFFICE REQUEST</b>
                          </h2>
                        </div>
                        <div className="col-sm-6"></div>
                      </div>
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-md-2"></div>
                    <div className="col-md-8"></div>
                    <div className="form-group col-md-2">
                      <form class="form-inline my-2 my-lg-0 float-right">
                        <div
                          class="btn-group p-2"
                          role="group"
                          aria-label="Basic example"
                        >
                          <button
                            type="button"
                            class="btn btn-secondary"
                            onClick={handleApprove}
                            disabled={checkedItems.length < 1 ? true : false}
                          >
                            {Loading ? load : " Approve selected"}
                          </button>
                          <button
                            type="button"
                            class="btn btn-danger"
                            onClick={handlereject}
                            disabled={checkedItems.length < 1 ? true : false}
                          >
                            {Loading ? load : "Reject Selected"}
                          </button>
                        </div>
                      </form>
                    </div>
                  </div>
                  <div className="table-responsive">
                    <table className="table table-bordered office-request-table">
                      {pendingRequests.data.length > 0 ? (
                        <thead>
                          <tr>
                            <th>SN</th>
                            <th>Employee Name</th>
                            <th>Request Type </th>
                            <th>Sub Category</th>
                            <th>Description</th>
                            <th>Price</th>
                            <th>Date Requested</th>

                            <th>
                              <div>
                                <input
                                  type="checkbox"
                                  onClick={handleAllChecked}
                                  value="checkedall"
                                  checked={checkedAll}
                                />{" "}
                                Check / Uncheck All
                              </div>
                            </th>
                            <th>Action</th>
                          </tr>
                        </thead>
                      ) : (
                        <div className="text-center m-auto">
                          <h1 className="text-dark">
                            No pending office requests
                          </h1>
                        </div>
                      )}
                      <tbody>
                        {pendingRequests.data.map((request, i) => (
                          <tr>
                            <td>{i + 1}</td>
                            <td>
                              {capitalize(request.created_by.first_name) +
                                " " +
                                capitalize(request.created_by.last_name)}
                            </td>
                            <td>{capitalize(request.request_type.name)}</td>
                            <td>
                              {request.request_category
                                ? capitalize(request.request_category.name)
                                : null}
                            </td>
                            <td>{capitalize(request.description)}</td>
                            <td>₦ {formattCurrency(request.price)}</td>
                            <td>
                              {moment(request.created_at).format(
                                "Do MMMM  YYYY"
                              )}
                            </td>
                            <td>
                              <Checkbox
                                handleCheckChieldElement={
                                  handleCheckChieldElement
                                }
                                {...request}
                              />
                            </td>
                            <td>
                              <a
                                class="dropdown-item"
                                id=""
                                onClick={() => {
                                  const value = {
                                    request_id: request.id,
                                    request_type: request.request_type.id,
                                    description: request.description,
                                    price: request.price,
                                    request_category:
                                      request.request_category.id,
                                  };
                                  setEditValue(value);
                                  openEditModal();
                                }}
                              >
                                <i
                                  style={{ cursor: "pointer" }}
                                  className="material-icons"
                                  data-toggle="tooltip"
                                  title="Edit"
                                >
                                  &#xE254;
                                </i>{" "}
                              </a>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                    <nav aria-label="...">
                      <ul class="pagination">
                        <li
                          class={`page-item ${pendingRequests.prev === null ? "disabled" : ""
                            }`}
                        >
                          <a
                            class="page-link"
                            onClick={() =>
                              getPendingRequests(pendingRequests.prev)
                            }
                            aria-disabled={
                              !pendingRequests.data.prev_page_url
                                ? "true"
                                : "false"
                            }
                          // aria-disabled={activityLog.prev_page_url}
                          >
                            Previous
                          </a>
                        </li>
                        {[...Array(pendingRequests.last).keys()].map(
                          (page, i) => (
                            <li
                              class={`page-item ${page + 1 === activePage ? "active" : ""
                                }`}
                              key={i}
                            >
                              <a
                                class="page-link"
                                id={page + 1}
                                onClick={() =>
                                  getPendingRequests(`?page=${page + 1}`)
                                }
                              >
                                {page + 1}
                              </a>
                            </li>
                          )
                        )}
                        <li
                          class={`page-item ${pendingRequests.next === null ? "disabled" : ""
                            }`}
                        >
                          <a
                            class="page-link"
                            onClick={() =>
                              getPendingRequests(pendingRequests.next)
                            }
                          >
                            {Loading ? load : "Next"}
                          </a>
                        </li>
                      </ul>
                    </nav>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};



// WEBPACK FOOTER //
// ./src/container/dashboard/pending/index.js